"use client"

import TeamCardV2 from "@/components/TeamCardV2"
import { ttFirsNeue } from "@/fonts"
import { cn } from "@/lib/utils"
import Link from "next/link"

import React from "react"

import useRetrieveUsers from "@/hooks/useRetrieveUsers"

const Team = () => {
  const { data: users } = useRetrieveUsers()

  const sortedUsers = users?.sort((a, b) => {
    if (a.position === "Venture Partner") return 1
    if (b.position === "Venture Partner") return -1
    if (a.position === "Advisor") return 1
    if (b.position === "Advisor") return -1
    return 0
  })

  return (
    <div className="w-full mt-24 md:mt-[140px] xl:mt-[154px] px-[1px] flex flex-col gap-8 xl:gap-16 md:gap-12">
      <div
        className={cn(
          "text-white text-[38px] md:text-[78px] font-medium leading-9 text-center",
          ttFirsNeue.className
        )}
      >{`Team`}</div>
      <div className="grid md:grid-cols-3 grid-cols-1 gap-4 xl:gap-6">
        {sortedUsers?.map((el, i) => (
          <Link href={`/team/${el?.id}`} key={i}>
            <TeamCardV2
              src={el?.avatar?.url}
              name={el?.fullname}
              position={el?.position}
            />
          </Link>
        ))}
      </div>
    </div>
  )
}

export default Team
